interface getMinBidRateProps {
  DT_rate?: number;
  SAPlus_rate?: number;
  BD_rate?: number;
  ED_rate?: number;
  RB_rate?: number;
  oneWayMiles?: number;
  oneWayTime?: number;
  loadPerDayPerTruck?: number;
  timeBuffer?: number;
  loadingTime?: number;
  unloadingTime?: number;
  deadheadForwardTime?: number;
  deadheadBackwardTime?: number;
  truckRate?: number;
}
interface getMultiLoadFuelProps {
  oneWayMiles?: number;
  loadPerDayPerTruck?: number;
  deadheadForwardMiles: number;
  deadheadBackwardMiles: number;
  oneWayTime: number;
  texasDieselAvg: number;
  truckMpgAvg: number;
  truckRate: number;
  percentage: number;
}
interface getHourlyLoadsPossibleProps {
  hour: number;
  totalDeadheadMinutes: number;
  minutesPerLoad: number;
}

interface MinutesPerLoadProps {
  oneWayTime?: number;
  loadingTime?: number;
  unloadingTime?: number;
  timeBuffer?: number;
}

export const getMinBidRate = ({
  DT_rate,
  SAPlus_rate,
  BD_rate,
  ED_rate,
  RB_rate,
  oneWayMiles,
  oneWayTime,
  loadPerDayPerTruck,
  timeBuffer,
  loadingTime,
  unloadingTime,
  truckRate,
  deadheadBackwardTime,
  deadheadForwardTime,
}: getMinBidRateProps) => {
  return (
    ((deadheadBackwardTime +
      deadheadForwardTime +
      loadingTime * loadPerDayPerTruck +
      unloadingTime * loadPerDayPerTruck +
      oneWayTime * 2 * loadPerDayPerTruck * (1 + timeBuffer)) *
      (truckRate / 60)) /
    loadPerDayPerTruck
  );
};

export const getMultiLoadFuelValues = ({
  oneWayTime,
  oneWayMiles,
  loadsPerDayTruck,
  deadheadForwardMiles,
  deadheadBackwardMiles,
  texasDieselAvg,
  truckMpgAvg,
  percentage,
}: getMultiLoadFuelProps) => {
  return (
    (((oneWayMiles * 2 * loadsPerDayTruck +
      deadheadForwardMiles +
      deadheadBackwardMiles) /
      truckMpgAvg) *
      texasDieselAvg) /
    (percentage / 100) /
    loadsPerDayTruck
  );
};

export const getMinutePerLoad = ({
  oneWayTime,
  loadingTime,
  unloadingTime,
  timeBuffer,
}: MinutesPerLoadProps) => {
  return (
    Number(loadingTime) +
    Number(unloadingTime) +
    Number(oneWayTime) * 2 * (1 + Number(timeBuffer))
  );
};

export const getHourlyLoadsPossible = ({
  totalDeadheadMinutes,
  minutesPerLoad,
  hour,
}: getHourlyLoadsPossibleProps) => {
  return (hour * 60 - totalDeadheadMinutes) / minutesPerLoad;
};

export const truckingUnit = {
  UNIT_LOAD:"load",
  UNIT_TON:"ton",
  UNIT_HOUR: "hour"
}


export const unitsOptionsDropdown = [
  {
    label: "Ton",
    value: truckingUnit.UNIT_TON,
  },
  {
    label: "Load",
    value: truckingUnit.UNIT_LOAD,
  },
  {
    label: "Hour",
    value: truckingUnit.UNIT_HOUR,
  },
];

export const truckTypeOption = [
  { label: "DT", value: "DT" },
  { label: "5A+", value: "5A+" },
  { label: "BD", value: "BD" },
  { label: "ED", value: "ED" },
  { label: "RB", value: "RB" },
];

export const fieldNames = {
  TEXAS_DIESEL_AVG: "texasDieselAvg",
  TRUCK_PRICE: "truckPrice",
  TRUCKING_COST: "truckingCost",
  ACTUAL_BID: "actualBid",
  TRUCK_MPG_AVG: "truckMPGAvg",
  TRUCK_TYPE: "truckType",
};

export const fieldUnitConstants = {
  TIME_BUFFER_UNIT: "%",
};

export const bidtoolFieldKeys = {
  initialPercentage: "initialPercentage",
  DT_rate: "DT_rate",
  SAPlue_rate: "5A+_rate",
  BD_rate: "BD_rate",
  ED_rate: "ED_rate",
  RB_rate: "RB_rate",
  oneWayMiles: "oneWayMiles",
  loadsPerDayTruck: "loadsPerDayTruck",
  timeBuffer: "timeBuffer",
  loadingTime: "loadingTime",
  unloadingTime: "unloadingTime",
  deadheadForwardTime: "deadheadForwardTime",
  deadheadBackwardTime: "deadheadBackwardTime",
  deadheadForwardMiles: "deadheadForwardMiles",
  deadheadBackwardMiles: "deadheadBackwardMiles",
  oneWayTime: "oneWayTime",
  texasDieselAvg: "texasDieselAvg",
};
